import { defineComponent as _defineComponent } from 'vue'
import tourCriteriaService from '@/js/common/Domain/Service/tourCriteria';
    import { Counter } from '@shared/ui';
    import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NightsRangeSelector',
  props: {
    nights: null
  },
  emits: ["control-changed"],
  setup(__props: any, { emit }: { emit: ({(e: 'control-changed', value: number): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { nights: number }

    
    

    const counterNights = computed({
        get: () => props.nights,
        set: (nights: number) => {
            tourCriteriaService.addTourCriteriaChangedField('nightRange');
            emit('control-changed', nights);
        },
    });


return { __sfc: true,props, emit, counterNights, Counter }
}

})